import { lazy } from 'react';

export default lazy(() => import(/* webpackChunkName: "stock-buysell-screen" */ './StockBuySell'));
